import { MouseEvent } from 'react';
import { IS_PROD_ENV } from '../initialisation/initialisation';
import { isProjectPhoenix } from '../international/internationalUtils';
import { PATHS } from '../routing-system/appPaths';
import browserHistory from '../routing-system/browserHistory';
import { PROJECT_PHOENIX_PALETTE } from '../theme';

export const truncate = (str: string, n: number, useWordBoundary: boolean) => {
  // courtesy of https://stackoverflow.com/a/1199420
  if (str.length <= n) {
    return str;
  }
  const subString = str.substring(0, n - 1);
  return `${useWordBoundary ? subString.substring(0, subString.lastIndexOf(' ')) : subString}…`;
};

export const isProductionEnv = () => {
  return IS_PROD_ENV;
};

export const isDevEnv = () => isLocalhost() || isDevKwiff() || isDevBetkwiff();

export const isLocalhost = () => window.location.origin.includes('localhost');

export const isDevKwiff = () => window.location.origin.endsWith(`.web.kwiff.org`);

export const isDevBetkwiff = () => window.location.origin.endsWith('.web.betkwiff.org');

export const redirectToLogin = () => {
  const currentUrl = `${browserHistory.location.pathname}${browserHistory.location.search}`;
  browserHistory.push(PATHS.LOGIN.ROOT, { redirectedFrom: currentUrl });
  return null;
};

export const shouldDisplayBanner = () => {
  // @ts-ignore
  return isProductionEnv() || !window.Cypress;
};

export const noop = () => undefined;

export const getScreenSize = (): { height: number; width: number } => ({
  height: window.screen.height,
  width: window.screen.width,
});

export const generateListIdFromTitle = (title: string) => {
  return title.toLowerCase().replace(' ', '-');
};

export const capitalizeFirstCharOfText = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const openNewTabCallback = (link: string) => () => {
  window.open(link, '_blank');
};

export const loadScript = (src: string) =>
  new Promise(resolve => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    // @ts-ignore
    script.onload = () => resolve();

    document.body.appendChild(script);
  });

export const getRandomNumberBetween = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1) + min);

export const preventDefaults = (event: MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
  event.stopPropagation();
  event.preventDefault();
};

export const getCustomMainAndSecondaryPalette = () => {
  if (isProjectPhoenix()) {
    return PROJECT_PHOENIX_PALETTE;
  }

  return undefined;
};
